// import { Button } from "@mui/material";
// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { useMutation, useQuery } from "react-query";
// import { toast } from "react-toastify";
// import DOMPurify from "dompurify";

// import { deleteSliderByIdFn, getSliderFn } from "../../Services/Slider";

// const Slider = () => {
//   const navigate = useNavigate();

//   const { data: getSliderResponse, refetch } = useQuery({
//     queryKey: ["get-slider"],
//     queryFn: getSliderFn,
//   });

//   const { mutate: deleteSlider } = useMutation(deleteSliderByIdFn, {
//     onSuccess: (response) => {
//       if (response?.data?.response_code === 200) {
//         toast.success("Deleted Successfully");
//         refetch();
//       }
//     },
//   });

//   const deleteHandle = (id) => {
//     const formData = new FormData();
//     formData.append("slider_id", id);
//     deleteSlider(formData);
//   };

//   return (
//     <div>
//       {/* Heading */}
//       <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
//         Slider
//       </p>

//       {/* Add Button */}
//       <div className="flex justify-end w-full px-2 mb-2">
//         <NavLink to="/slider/add">
//           <Button variant="outlined">Add</Button>
//         </NavLink>
//       </div>

//       {/* Slider Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
//         {getSliderResponse?.data?.data?.map((item) => {
//           const sanitizedTitle = DOMPurify.sanitize(item.title);

//           return (
//             <div
//               key={item.id}
//               className="flex flex-col justify-between p-3 border border-gray-300 rounded shadow hover:shadow-lg transition cursor-pointer bg-white"
//             >
//               <div className="flex justify-between items-center gap-3">
//                 {/* Title */}
//                 <p
//                   className="text-green-600 underline text-sm sm:text-base"
//                   dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
//                 />

//                 {/* Image */}
//                 {item?.image && (
//                   <img
//                     src={item.image}
//                     alt={item.title}
//                     className="w-24 h-20 object-cover rounded"
//                   />
//                 )}
//               </div>

//               {/* Action Buttons */}
//               <div className="flex justify-center gap-3 mt-4">
//                 <Button
//                   variant="outlined"
//                   onClick={() => navigate("/slider/update", { state: item.id })}
//                 >
//                   Update
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   color="error"
//                   onClick={() => deleteHandle(item.id)}
//                 >
//                   Delete
//                 </Button>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default Slider;

import { Button } from "@mui/material";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";

import { deleteSliderByIdFn, getSliderFn } from "../../Services/Slider";

const Slider = () => {
  const navigate = useNavigate();

  const { data: getSliderResponse, refetch } = useQuery({
    queryKey: ["get-slider"],
    queryFn: getSliderFn,
  });

  const { mutate: deleteSlider } = useMutation(deleteSliderByIdFn, {
    onSuccess: (response) => {
      if (response?.data?.response_code === 200) {
        toast.success("Deleted Successfully");
        refetch();
      }
    },
  });

  const deleteHandle = (id) => {
    const formData = new FormData();
    formData.append("slider_id", id);
    deleteSlider(formData);
  };

  return (
    <div>
      {/* Heading */}
      <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        Slider
      </p>

      {/* Add Button */}
      <div className="flex justify-end w-full px-2 mb-2">
        <NavLink to="/slider/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Slider Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {getSliderResponse?.data?.data?.map((item) => {
          const sanitizedTitle = DOMPurify.sanitize(item.title);

          return (
            <div
              key={item.id}
              className="flex flex-col justify-between p-3 border border-gray-300 rounded shadow hover:shadow-lg transition cursor-pointer bg-white"
            >
              <div className="flex justify-between items-center gap-3">
                {/* Title */}
                <p
                  className="text-green-600 underline text-sm sm:text-base"
                  dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
                />

                {/* Image */}
                {item?.image && (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-24 h-20 object-cover rounded"
                  />
                )}
              </div>
              <p className="mt-2 text-sm font-medium text-blue-600">
                 {item?.page_name || "Not Assigned"}
              </p>

              {/* Action Buttons */}
              <div className="flex justify-center gap-3 mt-4">
                <Button
                  variant="outlined"
                  onClick={() => navigate("/slider/update", { state: item.id })}
                >
                  Update
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => deleteHandle(item.id)}
                >
                  Delete
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Slider;
